import { http } from 'utils'

import { DATASTATUS } from 'constants/status'
import {
  AddTraderContactTypes,
  TraderContactDataTypes,
  UpdateTraderContactTypes,
} from 'types/corporateContacts'
import {
  CorporateContactsAPISchemas,
} from 'schemas/corporateContactsSchemas'

export async function getTraderContactsAPI(
  traderId: number
): Promise<{ data: TraderContactDataTypes[]; outcomeCode: string; outcomeMessage: string; outcomeUserMessage: string | null }> {
  const url = `/trader-contacts?traderId=${traderId}`
  const response = await http.get<{ data: TraderContactDataTypes[] }>(url)
  const validatedData = CorporateContactsAPISchemas.safeParse(response.data)

  if (!validatedData.success) {
    return {
      data: [],
      outcomeCode: DATASTATUS.outcomeCode,
      outcomeMessage: JSON.stringify(validatedData.error),
      outcomeUserMessage: DATASTATUS.outcomeUserMessage,
    }
  }

  return {
    data: validatedData.data.data,
    outcomeCode: validatedData.data.outcomeCode || '0',
    outcomeMessage: validatedData.data.outcomeMessage || 'Success!',
    outcomeUserMessage: validatedData.data.outcomeUserMessage,
  }
}

export async function addTraderContactAPI(
  payload: AddTraderContactTypes
): Promise<void> {
  const url = '/trader-contacts'
  return await http.post(url, payload)
}

export async function updateTraderContactAPI(
  payload: UpdateTraderContactTypes
): Promise<void> {
  const url = '/trader-contacts'
  return await http.patch(url, payload)
}